import { useEffect, useRef } from "react";
import { useLeaflet } from "react-leaflet";

const RRIGeotiffLayerRRI = ({ url, layerRef }) => {
  const { map } = useLeaflet();
  const internalRef = useRef(null);

  useEffect(() => {
    if (!map || !url) return;
    let cancelled = false;

    (async () => {
      try {
        const parseGeoraster = (await import('georaster')).default;
        const GeoRasterLayer = (await import('georaster-layer-for-leaflet')).default;

        const res = await fetch(url);
        const buffer = await res.arrayBuffer();
        const raster = await parseGeoraster(buffer);
        if (cancelled) return;

        const layer = new GeoRasterLayer({
          georaster: raster,
          opacity: 1,
            pixelValuesToColorFn: (values) => {
            const v = values[0];
            if (!v || v <= 0.1 || isNaN(v)) return null;
            if (v <= 50)   return '#E1F5FE';
            if (v <= 150)  return '#81D4FA';
            if (v <= 350)  return '#29B6F6';
            if (v <= 550)  return '#1976D2';
            if (v <= 750)  return '#5E35B1';
            if (v <= 1000) return '#8E24AA';
            if (v <= 1250) return '#C2185B';
            if (v <= 1500) return '#E53935';
            if (v <= 1800) return '#F4511E';
            if (v <= 2100) return '#E64A19';
            if (v <= 2400) return '#D32F2F';
            if (v <= 2700) return '#B71C1C';
            return '#7F0000';
            },
          resolution: 128,
          zIndex: 300,
        });

        layer.addTo(map);
        internalRef.current = layer;
        if (layerRef) layerRef.current = { leafletElement: layer };

      } catch (err) {
        console.error('RRI load error:', err);
      }
    })();

    return () => {
      cancelled = true;
      if (internalRef.current) {
        map.removeLayer(internalRef.current);
        internalRef.current = null;
      }
    };
  }, [url]);

  return null;
};

export default RRIGeotiffLayerRRI;